import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Bloqueia rotas que exigem JWT. Sem token → redireciona para /login
 * guardando a rota pretendida em returnUrl. É a porta de entrada da app,
 * avaliada antes do sessaoGuard (identificação por nome).
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.autenticado()) {
    return true;
  }
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url },
  });
};
